export default __webpack_public_path__ + "static/media/Trillium-960px-360px.jpg.80dbda2a.webp";